import {
  AppstoreOutlined,
  TableOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { Select, Tooltip } from "antd";

const { Option } = Select; // Destructure Option

export type LayoutView = "grid" | "list" | "table";

interface LayoutSwitcherProps {
  layout: LayoutView;
  setLayout: (layout: LayoutView) => void;
  disabled?: boolean;
}

const LayoutSwitcher = ({
  layout,
  setLayout,
  disabled,
}: LayoutSwitcherProps) => {
  // Define icons for each layout view
  const layoutIcons: Record<LayoutView, React.ReactNode> = {
    table: <TableOutlined />,
    grid: <AppstoreOutlined />,
    list: <UnorderedListOutlined />,
  };

  // Options structure removed, defined directly below

  return (
    <Tooltip title="Change Layout View">
      <Select<LayoutView>
        value={layout}
        onChange={setLayout}
        disabled={disabled}
        // options prop removed
        size="middle"
        aria-label="Change Layout View"
        optionLabelProp="label" // Use the Option's 'label' prop for collapsed display
        labelInValue={false}
        popupMatchSelectWidth={false}
        dropdownRender={(menu) => (
          <div style={{ minWidth: "120px" }}>{menu}</div>
        )}
      >
        <Option
          key="list"
          value="list"
          label={layoutIcons.list}
          title="List View"
        >
          {/* Display in dropdown */}
          <>{layoutIcons.list} List View</>
        </Option>
        <Option
          key="grid"
          value="grid"
          label={layoutIcons.grid}
          title="Grid View"
        >
          {/* Display in dropdown */}
          <>{layoutIcons.grid} Grid View</>
        </Option>
        {/* <Option key="table" value="table" label={layoutIcons.table} title="Table View">
        <>
          {layoutIcons.table} Table View
        </>
      </Option> */}
      </Select>
    </Tooltip>
  );
};

export default LayoutSwitcher;
